import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  viewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import {
  CONFIRM_DIALOG_MESSAGE,
  CONFIRM_DIALOG_MESSAGE_DELETE,
} from "../../locale/consts.en";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import { MasterDataService } from "../master-data/master-data-service";
import { Area } from "../master-data/master-data.model";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { DatabaseService } from "../shared/database.service";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";

@Component({
  selector: "app-areas",
  templateUrl: "./areas.component.html",
  styleUrls: ["./areas.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AreasComponent implements OnInit, AfterViewInit {
  private dialog = inject(MatDialog);
  private masterDataService = inject(MasterDataService);
  private databaseService = inject(DatabaseService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly sort = viewChild(MatSort);
  dataSource: MatTableDataSource<Area>;
  displayedColumns: string[] = ["name", "externalId", "edit", "delete"];
  areas: Area[] = [];

  ngOnInit(): void {
    const areas = this.route.snapshot.data.areas ?? [];
    this.areas = sortByStringWithEmptyAtEnd(areas, (item) => item.name);
    // this.route.snapshot.data.areas.sort((a, b) => a.name.localeCompare(b.name));
    this.dataSource = new MatTableDataSource(this.areas);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveAreaToApi(area: Area) {
    this.masterDataService
      .updateArea(area)
      .pipe(
        finalize(() => {
          this.masterDataService
            .getAreas()
            .pipe(first())
            .subscribe((areas) => {
              this.areas = areas;
              this.dataSource.data = this.areas;
            });
        }),
      )
      .subscribe({
        next: (response) => {
          this.masterDataService.handleResponse(response);
        },
        error: () => this.masterDataService.savingErrorMessage(),
      });
  }

  updateArea(t: Area) {
    const area = new Area();
    Object.assign(area, t);
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: area,
    });
    dialogRef.afterClosed().subscribe(async (data: Area) => {
      if (data != null) {
        this.saveAreaToApi(data);
      }
    });
  }

  deleteArea(area: Area) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_MESSAGE,
      CONFIRM_DIALOG_MESSAGE_DELETE,
      ConfDialogType.MESSAGE,
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
  }

  onAddArea() {
    const area = new Area();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: area,
    });
    dialogRef.afterClosed().subscribe(async (data: Area) => {
      if (data != null) {
        this.saveAreaToApi(data);
      }
    });
  }

  onBack() {
    this.router.navigate(["/"]);
  }
}
